export const FORMIC_REQUEST_HEADER_NAME = 'X-Formic-Request';
export const FORMIC_REQUEST_HEADER_VALUE = 'OnlineForms2';

export const formicRequestHeaders: Readonly<Record<string, string>> = {
  [FORMIC_REQUEST_HEADER_NAME]: FORMIC_REQUEST_HEADER_VALUE,
};

const formImagePrefix = 'formImages/';
const formImageFilenamePattern =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.(?:png|jpe?g|gif|webp|bmp)$/i;
const maximumFormImageFilenameLength = 64;
const maximumProjectId = 2_147_483_647;

export class BffRequestError extends Error {
  public readonly status: number;

  constructor(operation: string, status: number) {
    super(`${operation} request failed with status ${status}.`);
    this.name = 'BffRequestError';
    this.status = status;
  }
}

export const requireSuccessfulBffResponse = (response: Response, operation: string): Response => {
  if (!response.ok) throw new BffRequestError(operation, response.status);
  return response;
};

export const bffRoutes = {
  graphql: '/bff/graphql',
  records: '/bff/records',
  download: '/bff/download',
  dataDerivation: '/bff/dataderivation',
  validate: '/bff/validate',
  urlValidation: '/bff/urlvalidation',
  plugins: '/bff/plugins',
  formImage: (apiPath: string, projectId: number): string => {
    if (!Number.isSafeInteger(projectId) || projectId <= 0 || projectId > maximumProjectId) {
      throw new Error('Invalid form image project identifier.');
    }

    if (!apiPath.startsWith(formImagePrefix)) {
      throw new Error('Invalid form image path.');
    }

    const filename = apiPath.slice(formImagePrefix.length);
    if (
      filename.length === 0 ||
      filename.length > maximumFormImageFilenameLength ||
      !formImageFilenamePattern.test(filename)
    ) {
      throw new Error('Invalid form image path.');
    }

    return `/bff/form-images/${projectId}/${encodeURIComponent(filename)}`;
  },
} as const;
